export default "__VITE_ASSET__3bd21766__"